import { isNil, path, split } from 'ramda';

const hasError = (errors, name) => {
  const errorPath = split('.', name);
  const errorMessage = path(errorPath, errors);

  return !isNil(errorMessage) && !isNil(errorMessage.message);
};

export default hasError;
